<template>
  <el-popover
    placement="bottom"
    width="200"
    trigger="hover">
    <el-slider
      :min="0"
      :step="step"
      @change="handleSliderChange"
      v-model="precent"
      :format-tooltip="formatTooltip"
    ></el-slider>
    <div class="flex-inline" slot="reference">
      <el-input class="welfare-input" @blur="handleWelfareChange" v-model="thisValue.welfare">
        <span slot="prefix" class="el-input__icon pl-5">¥</span>
      </el-input>
      <div class="ml-10">或</div>
      <el-input class="welfare-input ml-10" @blur="handleWelfarePrecentChange" v-model="precent">
        <span slot="suffix" class="el-input__icon pl-5">%</span>
      </el-input>
    </div>
  </el-popover>
</template>

<script>
export default {
  props: ['value'],
  data() {
    return {
      thisValue: this.value,
      step: 1,
      precent: Math.floor(this.value.welfare / this.value.shop_price * 100) || 20,
      timer: null
    };
  },
  watch: {
    // 监听零售价的变化
    "value.shop_price": function(v) {
      // 当零售价变化时  折扣百分比恢复默认值20 更新数据
      let welfareTemp = parseInt( parseFloat(v) * 20 / 100);
      if(welfareTemp <=  1){
        // 最低抵扣金额 1元 
        this.thisValue.welfare = 1
        this.updatePrecent()
      }else{
        this.thisValue.welfare = welfareTemp
        this.precent = 20;
      }
      if (v > 40) {
        this.step = 1;  
      } else if (v > 10) {
        this.step = 5
      } else if (v <= 10 ){
        this.step = 10
      }
      this.$emit('input', this.thisValue);
    }
  },
  computed: {
    
  },
  methods: {
    // 更新百分比
    updatePrecent() {
      this.precent = Math.floor(this.thisValue.welfare*100/this.thisValue.shop_price);
    },
    formatTooltip(val) {
      return val + '%';
    },
    // 监听滑动条
    handleSliderChange(val) {
      if(!this.thisValue.shop_price){
        return
      }
      // 按照百分比重新结算
      // 向上取整  如果太大了就返回-1  （向下取整有可能低于10%，会引发错误）
      let num = Math.ceil(this.thisValue.shop_price * val / 100);

      // 实际福利券额度不能高于商品价格
      if (num > this.thisValue.shop_price) {
        this.$message.error('福利券抵扣额度不能高于商品价格')
        num = Math.floor(this.thisValue.shop_price);
      }

      this.thisValue.welfare = num
      // 福利券抵扣金额 必须为整数 需要重新计算当前百分比
      this.updatePrecent()
      this.$emit('input', this.thisValue);
    },
    handleWelfarePrecentChange(e) {
      // 判断是否有零售价
      if(!this.thisValue.shop_price){
        return
      }
      let inputValue = e.target.value;
      
      // 金额取整
      let _realValue = parseInt(inputValue);
      if (isNaN(_realValue)) {
        this.$message.error('请输入正确的折扣比例')
        _realValue = 20
      }

      // if (_realValue < 10) {
      //   this.$message.error('折扣比例不能低于10%')
      //   _realValue = 10
      // }

      if (_realValue > 100) {
        this.$message.error('折扣比例不能大于100%')
        _realValue = 100
      }

      // 计算折扣金额
      let _nowWelfare = Math.ceil( this.thisValue.shop_price * _realValue / 100 )
      if(_nowWelfare>this.thisValue.shop_price){
        _nowWelfare = Math.floor(this.thisValue.shop_price);
      }
      this.thisValue.welfare = _nowWelfare
      this.precent = _realValue

      this.$emit('input', this.thisValue);
    },
    // 监听福利券抵扣输入
    handleWelfareChange(e){
      // 判断是否有零售价
      if(!this.thisValue.shop_price) {
        return
      }
      
      let inputValue = e.target.value;
      // 金额取整
      let _realValue = parseInt(inputValue);
      if (isNaN(_realValue)||_realValue<=0) _realValue = 1

      // 福利券校验
      // 福利券不能大于零售价，否则后台会出现计算错误
      if (_realValue > this.thisValue.shop_price) {
        this.$message.error('福利券抵扣额度不能高于商品价格')
        _realValue = Math.floor(this.thisValue.shop_price)
      }
      // 折扣率校验
      // 计算此时的福利券折扣额度
      // let _nowPrecent = Math.floor(_realValue * 100 / this.thisValue.shop_price);

      // 当折扣额度小于10% 时，手动指定
      // if (_nowPrecent < 10) {
      //   this.$message.error('福利券抵扣额度不能低于10%')
      //   // 此处10%折扣率 即为福利券最低价格  因此采取进一法保证计算出来的福利券 对应的折扣率大于10%
      //   _realValue = Math.ceil(this.thisValue.shop_price / 10)
      // }

      // 得到实际福利券额度
      this.thisValue.welfare = _realValue;

      // 更新滑块显示
      this.updatePrecent()
      this.$emit('input', this.thisValue);
    }
  }
}
</script>
<style lang="scss" scoped>
.welfare-input ::v-deep .el-input-group__append {
  padding: 0 5px;
  width: 46px;
}
</style>